import cn from "classnames";

import styles from "./RectangleSkeleton.module.scss";

const RectangleSkeleton = ({
  width,
  height,
  className,
  desktopOnly,
}: {
  width: string;
  height: string;
  className?: string;
  desktopOnly?: boolean;
}) => {
  return (
    <div
      className={cn([
        styles.rectangleSkeleton,
        desktopOnly && styles.desktopOnly,
        className,
      ])}
      style={{ width, height }}
    ></div>
  );
};

export { RectangleSkeleton };
